/**
 * Knowledge Base Document entity (файл для RAG)
 */
export interface KnowledgeDocument {
  id: number;
  filename: string;
  mimeType: string;
  fileSize: number;
  filePath: string;
  status: "PENDING" | "PROCESSING" | "COMPLETED" | "FAILED";
  error: string | null;
  chunksCount: number;
  createdAt: string;
  updatedAt: string;
}

/**
 * Результат загрузки документа
 */
export interface UploadResult {
  id: number;
  filename: string;
  mimeType: string;
  size: number;
  status: "PENDING";
  jobId: string;
  message: string;
}

/**
 * Статус обработки документа
 */
export interface DocumentJobStatus {
  document: {
    id: number;
    filename: string;
    status: KnowledgeDocument["status"];
    error: string | null;
    chunksCount: number;
  };
  job: {
    id: string;
    state: string;
    progress: number;
    attemptsMade: number;
    failedReason?: string;
  } | null;
}

/**
 * Поддерживаемые MIME типы для загрузки
 */
export const SUPPORTED_MIME_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
  "text/csv",
  "text/plain",
] as const;

/**
 * Человекочитаемые названия форматов
 */
export const FILE_TYPE_LABELS: Record<string, string> = {
  "application/pdf": "PDF",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Word (DOCX)",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "Excel (XLSX)",
  "application/vnd.ms-excel": "Excel (XLS)",
  "text/csv": "CSV",
  "text/plain": "Текст (TXT)",
};

/**
 * Расширения файлов для input accept
 */
export const ACCEPTED_FILE_EXTENSIONS = ".pdf,.docx,.xlsx,.xls,.csv,.txt";
